exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".input-268d7{width:100%}.amountInput-d805d{width:100%;padding:0}.amountInput-d805d input{padding:8px 12px !important}", ""]);

// Exports
exports.locals = {
	"input": "input-268d7",
	"amountInput": "amountInput-d805d"
};